// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-filter {
    margin: 10px;
    position: relative;
}

.search-bar {
    display: flex;
    align-items: center;
    border: 1px solid rgba(36, 42, 101, 0.4);
    border-radius: 8px;
    padding: 4px 8px;
    background: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 0 0 2px rgba(36, 42, 101, 0.3);
}

.search-bar:focus-within {
    border-color: rgb(36, 42, 101);
    box-shadow: 0 0 0 2px rgba(36, 42, 101, 0.4);
}

.search-input {
    flex: 1 1;
    background: none;
    border: none;
    outline: none;
    color: white;
    font-size: 14px;
    padding: 6px 8px;
}

.search-input::placeholder {
    color: #6F7A96;
    font-style: italic;
}

.search-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    background: rgba(18, 22, 50, 0.95); /* same tone family as input bg */
    border: 1px solid rgba(36, 42, 101, 0.4);
    border-radius: 8px;
    box-shadow: 0 0 0 2px rgba(36, 42, 101, 0.3);
    z-index: 1000;
    list-style: none;
    padding: 4px 0;
    margin: 0;
    max-height: 220px;
    overflow-y: auto;
    -webkit-backdrop-filter: blur(6px);
            backdrop-filter: blur(6px);
}

.dropdown-item {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 14px;
    color: #e8ebf7; /* slightly off-white, like your input text */
    transition: background-color 0.15s ease, color 0.15s ease;
}

.dropdown-item span.tag-color {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
}

.dropdown-item:hover {
    background-color: rgba(36, 42, 101, 0.3);
    color: white;
}

.item-type {
    font-size: 12px;
    color: #6f7a96;
    margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchFilter.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,wDAAwD;IACxD,4CAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;AAChD;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,kCAAkC,EAAE,iCAAiC;IACrE,wCAAwC;IACxC,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc,EAAE,6CAA6C;IAC7D,yDAAyD;AAC7D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".search-filter {\n    margin: 10px;\n    position: relative;\n}\n\n.search-bar {\n    display: flex;\n    align-items: center;\n    border: 1px solid rgba(36, 42, 101, 0.4);\n    border-radius: 8px;\n    padding: 4px 8px;\n    background: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 0 0 2px rgba(36, 42, 101, 0.3);\n}\n\n.search-bar:focus-within {\n    border-color: rgb(36, 42, 101);\n    box-shadow: 0 0 0 2px rgba(36, 42, 101, 0.4);\n}\n\n.search-input {\n    flex: 1;\n    background: none;\n    border: none;\n    outline: none;\n    color: white;\n    font-size: 14px;\n    padding: 6px 8px;\n}\n\n.search-input::placeholder {\n    color: #6F7A96;\n    font-style: italic;\n}\n\n.search-dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    width: 100%;\n    background: rgba(18, 22, 50, 0.95); /* same tone family as input bg */\n    border: 1px solid rgba(36, 42, 101, 0.4);\n    border-radius: 8px;\n    box-shadow: 0 0 0 2px rgba(36, 42, 101, 0.3);\n    z-index: 1000;\n    list-style: none;\n    padding: 4px 0;\n    margin: 0;\n    max-height: 220px;\n    overflow-y: auto;\n    backdrop-filter: blur(6px);\n}\n\n.dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #e8ebf7; /* slightly off-white, like your input text */\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.dropdown-item span.tag-color {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 8px;\n    flex-shrink: 0;\n}\n\n.dropdown-item:hover {\n    background-color: rgba(36, 42, 101, 0.3);\n    color: white;\n}\n\n.item-type {\n    font-size: 12px;\n    color: #6f7a96;\n    margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
